import React, { Component } from 'react';
import '../../../src/styles/Journals.css';
import Tabs from 'react-bootstrap/Tabs'
import Tab from 'react-bootstrap/Tab'
import { appService } from '../../_services';
import DocumentMeta from 'react-document-meta';
import { Link } from 'react-router-dom';
import ReactGA from 'react-ga';
export class Subscription extends Component {
    displayName = Subscription.name
    constructor(props) {
        super(props);
        this.state = {
            subscriptionList:[]
        }
        this.SetOrderBy = this.SetOrderBy.bind(this);
    }

    componentDidMount(){
        var self = this;
        var username = "";
        if (localStorage.getItem('user') !== null) {
            username = localStorage.getItem('user');
        }

        var parameters = { user: JSON.parse(username) };

        appService.getByIssueId('Product/GetSubscriptionDetail', parameters).then(function (data) {
            //console.log(data);
            if (data == "Error found") {
                //window.location = "/Maintenance";;
            }
         
            self.setState({ subscriptionList : data });
        });

        ReactGA.initialize(
            [
                {
                    trackingId: 'UA-2905701-8',
                    gaOptions: { name: 'tracker1' }
                },
                {
                    trackingId: 'UA-72849501-2',
                    gaOptions: { name: 'tracker2' }
                }
            ],
            { alwaysSendToDefaultTracker: false }
        );

        ReactGA.pageview(window.location.pathname, ['tracker1', 'tracker2'], "Kluwer Law Online - Subscription");
        var metas = document.getElementsByTagName('meta');
        for (let i = 0; i < metas.length; i++) {
            if (metas[i].getAttribute('name') == "robots") {
                console.log(metas[i]);
                metas[i].remove();
            }
        }
    }

    SetOrderBy(key) {
       
        if (key.indexOf('Practice areas') > -1) {
            this.setState({
                subscriptionList : this.state.subscriptionList.sort((a, b) => a.topic.localeCompare(b.topic))
            })
            
        }
        else {
            this.setState({
                subscriptionList: this.state.subscriptionList.sort((a, b) => a.title.localeCompare(b.title))
            })
        }
    }

    render() {
        const meta = {
            title: "Kluwer Law Online - Subscription",
            canonical: window.location.href,
        }

        var journalCount = this.state.subscriptionList.filter(prd=>prd.productType=="1").length;
        var manualCount = this.state.subscriptionList.filter(prd=>prd.productType=="2").length;
        var encyclopediaCount = this.state.subscriptionList.filter(prd=>prd.productType=="3").length;
        // Accepts the array and key
        const groupBy = (array, key) => {
            // Return the end result
            return array.reduce((result, currentValue) => {
            // If an array already present for key, push it to the array. Else create an array and push the object
            (result[currentValue[key]] = result[currentValue[key]] || []).push(
                currentValue
            );
            // Return the current iteration `result` value, this will be taken as next iteration `result` value and accumulate
            return result;
            }, {}); // empty object is the initial value for result object
        };
        const subscriptionListByTopic = groupBy(this.state.subscriptionList, 'topic');

        //console.log(subscriptionListByTopic);
        return (
            <DocumentMeta {...meta}>
            <div className="col-12">
                <div className="row">
                    <div className="col-lg-12 colPadding margintop">
                        <p className="franziskafont">Your online subscriptions</p>
                    </div>
                </div>

                <div className="row AllColPadding margintop">
                    <div className="col-lg-12">
                            <Tabs className="flex-tabs Tabfont" defaultActiveKey="1" id="uncontrolled-tab-example" onSelect={this.SetOrderBy}>
                            <Tab eventKey="1"  title={"All ("+ this.state.subscriptionList.length +")"}>
                                <br></br>  <br></br>
                                <div className="col-lg-9 TopicPadding">
                                    {
                                            this.state.subscriptionList.map(item => {
                                            var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
                                        return (
                                            <div>
                                                <div className="JournalFlex" style={{ height: '180px' }}>
                                                    <Link to={"/" + (item.productType == "1" ? "Journals" : item.productType == "2" ? "Manuals" : "Encyclopedias") + "/" + titlePlus + "/" + item.id} style={{ cursor: 'pointer' }}>
                                                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" />
                                                    </Link>
                                                <div style={{width:'100%'}}>
                                                        <h4 className="paddingL BookHeading">
                                                            <Link to={"/" + (item.productType == "1" ? "Journals" : item.productType == "2" ? "Manuals" : "Encyclopedias") + "/" + titlePlus + "/" + item.id} className="LinkClass HoverUnderline">{item.title} </Link>
                                                        </h4>
                                                        <p className="paddingL BookBody"><div dangerouslySetInnerHTML={{ __html: item.description }} style={{ height: '68px' }}></div>
                                                            <p className="grey-text-on-white-bg">
                                                            {item.productType=="1"? "Journal" : item.productType=="2"? "Manual" : "Encyclopedia"}
                                                         <hr className="HrCSS"></hr></p> </p>
                                                    </div>
                                                </div>
                                            </div>
                                            )})
                                    }
                                </div>
                            </Tab>
                            <Tab eventKey={"Journals ("+ journalCount +")"} title={"Journals ("+ journalCount +")"}>
                                <br></br>  <br></br>
                                <div className="col-lg-9 TopicPadding">
                                  {
                                     this.state.subscriptionList.filter(prd=>prd.productType=="1").map(item =>
                                            {
                                                var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
                                        return (
                                            <div>
                                                <div className="JournalFlex" style={{ height: '180px' }}>
                                                    <Link to={"/Journals/" + titlePlus + "/" + item.id} style={{ cursor: 'pointer' }}>
                                                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" />
                                                    </Link>
                                                <div style={{ width: '100%' }}>
                                                        <h4 className="paddingL BookHeading">
                                                            <Link to={"/Journals/" + titlePlus + "/" + item.id} className="LinkClass HoverUnderline">{item.title} </Link>
                                                        </h4>
                                                        <p className="paddingL BookBody"><div dangerouslySetInnerHTML={{ __html: item.description }} style={{ height: '68px' }}></div>
                                                        <p className="grey-text-on-white-bg">Journal<hr className="HrCSS"></hr></p> </p>
                                                    </div>
                                                </div>
                                             </div>
                                            );
                                        }
                                      )
                                    }
                                </div>
                            </Tab>
                            <Tab eventKey={"Encyclopaedias ("+ encyclopediaCount +")"} title={"Encyclopaedias ("+ encyclopediaCount +")"}>
                                <br></br>  <br></br>
                                <div className="col-lg-9 TopicPadding">
                                {
                                     this.state.subscriptionList.filter(prd=>prd.productType=="3").map(item =>
                                            {
                                                var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
                                        return (
                                            <div>
                                                <div className="JournalFlex" style={{ height: '180px' }}>
                                                    <Link to={"/Encyclopedias/" + titlePlus + "/" + item.id} style={{ cursor: 'pointer' }}>
                                                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" />
                                                    </Link>
                                                <div style={{ width: '100%' }}>
                                                        <h4 className="paddingL BookHeading">
                                                            <Link to={"/Encyclopedias/" + titlePlus + "/" + item.id} className="LinkClass HoverUnderline">{item.title} </Link>
                                                        </h4>
                                                        <p className="paddingL BookBody"><div dangerouslySetInnerHTML={{ __html: item.description }} style={{ height: '68px' }}></div>
                                                        <p className="grey-text-on-white-bg">Encyclopedia <hr className="HrCSS"></hr></p> </p>
                                                    </div>
                                                </div>
                                             </div>
                                            );
                                        }
                                      )
                                    }
                                </div>
                            </Tab>
                            <Tab eventKey={"Manuals ("+ manualCount +")"} title={"Manuals ("+ manualCount +")"}>
                                <br></br>  <br></br>
                                <div className="col-lg-9 TopicPadding">
                                {
                                     this.state.subscriptionList.filter(prd=>prd.productType=="2").map(item =>
                                            {
                                                var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
                                        return (
                                            <div>
                                                <div className="JournalFlex" style={{ height: '180px' }}>
                                                    <Link to={"/Manuals/" + titlePlus + "/" + item.id} style={{ cursor: 'pointer' }}>
                                                        <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" />
                                                    </Link>
                                                <div style={{ width: '100%' }}>
                                                        <h4 className="paddingL BookHeading">
                                                            <Link to={"/Manuals/" + titlePlus + "/" + item.id} className="LinkClass HoverUnderline">{item.title} </Link>
                                                        </h4>
                                                        <p className="paddingL BookBody"><div dangerouslySetInnerHTML={{ __html: item.description }} style={{ height: '68px' }}></div>
                                                        <p className="grey-text-on-white-bg">Manual <hr className="HrCSS"></hr></p> </p>
                                                    </div>
                                                </div>
                                             </div>
                                            );
                                        }
                                      )
                                    }
                                </div>
                            </Tab>
                            <Tab eventKey={"Practice areas (" + Object.entries(subscriptionListByTopic).length + ")"} title={"Practice areas (" + Object.entries(subscriptionListByTopic).length+")"}>
                                <br></br>  <br></br>
                                {Object.entries(subscriptionListByTopic).map((topicItem, index) =>
                                {
                                    return(
                                        <div>
                                            <h4 className="PublicationTitle">{topicItem[0]} </h4>
                                        <br></br> 
                                        <div className="col-lg-9 TopicPadding">
                                                {topicItem[1].map(item => {
                                                    var titlePlus = typeof item.title == 'undefined' ? "" : item.title.replace(/ /g, "+");
                                                    return (<div>
                                                        <div className="JournalFlex" style={{ height: '180px' }}>
                                                            <Link to={"/" + (item.productType == "1" ? "Journals" : item.productType == "2" ? "Manuals" : "Encyclopedias") + "/" + titlePlus + "/" + item.id} style={{cursor:'pointer'}}>
                                                                <img alt={"Cover Image for " + item.title} src={"/../../images/books/" + item.imageUrl} className="JounrnalImg" />
                                                                </Link>
                                                            <div style={{ width: '100%' }}>
                                                                <h4 className="paddingL BookHeading">
                                                                    <Link to={"/" + (item.productType == "1" ? "Journals" : item.productType == "2" ? "Manuals" : "Encyclopedias") + "/" + titlePlus + "/" + item.id} className="LinkClass HoverUnderline">{item.title} </Link>
                                                                </h4>
                                                                    <p className="paddingL BookBody"> <div dangerouslySetInnerHTML={{ __html: item.description }} style={{ height: '68px' }}></div>
                                                                    <p className="grey-text-on-white-bg">{item.productType=="1"? "Journal" : item.productType=="2"? "Manual" : "Encyclopedia"} <hr className="HrCSS"></hr></p> </p>
                                                                </div>
                                                            </div>
                                                        </div>);
                                            })}                                           
                                        </div></div>
                                        );
                                  })
                                }
                            </Tab>
                        </Tabs>
                    </div>
                </div>
            </div>
                </DocumentMeta>


        );
    }
}
export default Subscription;


// WEBPACK FOOTER //
// ./src/components/Your Subscription/Subscription.jsx